<template>
  <div id="text_file_select" class="d-flex justify-content-between">
    <label for="textArea">{{ $t('message.text') }}:</label>
    <textarea id="textArea" class="form-control" v-model="text"
      :placeholder="$t('message.enterText')"></textarea>

    <label for="textFileInput">{{ $t('message.orUploadDocument') }}:</label>
    <div class="file_select_container">
      <button @click="triggerTextFileInput" class="mx-auto">{{ $t('message.chooseFile') }}</button>
      <span class="border p-2 text-primary" v-if="selectedTextFileName">{{ selectedTextFileName }}</span>
      <label>
        <input type="file" ref="textFileInput" @change="uploadFile" id="textFileInput"
          accept=".txt,.rtf" style="display: none;" />
      </label>
    </div>

    <div v-if="isLoading" class="loader">{{ $t('message.loading') }}...</div>
  </div>
</template>

<script>
export default {
  name: 'TextInput',

  data() {
    return {
      text: '',
      isLoading: false,
      selectedTextFileName: '',
    };
  },

  watch: {
    text: function (val) {
      this.$emit('childEvent', val);
    },
  },

  created() {
    const items = ['selectedTextFileName', 'text'];
    items.forEach((item) => {
      const value = localStorage.getItem(item);
      if (value !== null && value !== 'undefined') {
        try {
          this[item] = JSON.parse(value);
        } catch {
          // ignore
        }
      }
    });
  },

  methods: {
    uploadFile(e) {
      const file = e.target.files[0];
      if (!file) return;

      this.selectedTextFileName = file.name;
      localStorage.setItem('selectedTextFileName', JSON.stringify(this.selectedTextFileName));
      this.isLoading = true;

      const reader = new FileReader();
      reader.onload = (event) => {
        this.text = event.target.result;
        this.$emit('childEvent', this.text);
        localStorage.setItem('text', JSON.stringify(this.text));
        this.isLoading = false;
      };
      reader.onerror = () => {
        console.error('Failed to read file');
        this.isLoading = false;
      };
      reader.readAsText(file, 'UTF-8');
    },

    triggerTextFileInput() {
      this.$refs.textFileInput.click();
    },
  },
};
</script>

<style scoped>
#text_file_select {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 400px;
  margin: auto;
}

#text_file_select label {
  font-size: 1.1rem;
  font-weight: 500;
}

#text_file_select span {
  display: block;
  margin-left: 10px;
  margin-top: 5px;
  font-size: 0.9rem;
  color: #444;
}

.file_select_container {
  display: flex;
  align-items: center;
}

.file_select_container button {
  padding: 10px 10px;
  font-size: 0.9rem;
  color: white;
  background-color: var(--ochre);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-family: var(--font-heading);
}

.file_select_container button:hover {
  background-color: var(--ink-dark);
}

.file_select_container button:disabled {
  background-color: grey;
}

.file_select_container span {
  font-size: 0.9rem;
}

.loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#textarea {
  width: 100%;
  height: 200px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 16px;
  transition: all 0.3s ease-in-out;
}

#textarea:hover {
  border: 2px solid #4285f4;
  background-color: #fff;
  box-shadow: 0 0 5px #4285f4;
  transform: scale(1.05);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
